import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import { toast } from "react-hot-toast";
import { redirect } from "next/navigation";
import config from "@/config";

interface ErrorResponse {
  error?: string;
  message?: string;
}

// use this to interact with our own API (/app/api folder) from the front-end side
// See https://shipfa.st/docs/tutorials/api-call
const apiClient: AxiosInstance = axios.create({
  baseURL: "/api",
  withCredentials: true, // Include cookies in requests
});

apiClient.interceptors.response.use(
  function <T>(response: AxiosResponse<T>): T {
    return response.data;
  },
  function (error: AxiosError<ErrorResponse>) {
    let message = "";

    if (error.response?.status === 401) {
      // User not auth, ask to re login
      toast.error("Please login");
      // Sends the user to the login page
      redirect(config.auth.loginUrl);
    } else if (error.response?.status === 403) {
      // User not authorized, must subscribe/purchase/pick a plan
      message = "Pick a plan to use this feature";
    } else {
      message =
        error?.response?.data?.error || 
        error?.response?.data?.message ||
        error.message || 
        error.toString();
    }

    const errorMessage =
      typeof message === "string" ? message : JSON.stringify(message);

    console.error(errorMessage);

    // Automatically display errors to the user
    if (errorMessage) {
      toast.error(errorMessage);
    } else {
      toast.error("something went wrong...");
    }
    
    // Create a new error with the processed message
    const processedError = new Error(errorMessage) as AxiosError;
    return Promise.reject(processedError);
  }
);

export default apiClient;